angular.module("gifts")

    .controller("GiftsListCtrl", ['LoginService','$state', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', 'datasetsService',
        function (LoginService, $state, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, datasetsService) {

            $scope.giftsFilter = {};
            let filter = false;
            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("GIFTS_WRITE");

            Restangular.all('Providers').getList().then(function (providers) {
                $scope.selectProviders = providers;
            });


            $rootScope.title = $filter('translate')('gifts.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('gifts.title') }
            ];

            $scope.gridOptionsGifts = {
                pdfTitle: $filter('translate')('gifts.pdf_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                exporterSuppressColumns: ["image_id"], //porque con url en vez de la imagen en base64 no se puede generar
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        field: 'image_id',
                        enableSorting: false,
                        width: 60,
                        enableFiltering: false,
                        displayName: $filter('translate')('political_affiliations.logo'),
                        cellTemplate: "<div style='height: 28px; overflow: hidden; text-align: center'><img width=\"28px\" ng-show=\"grid.getCellValue(row, col)\" ng-src=\"/api/Image/GetImageBmp?id={{row.entity.image_id}}&maxW=28&maxH2=28\" style=\"margin-top:0px\" lazy-src></div>"
                    },
                  { name: 'name', displayName: $filter('translate')('gifts.name'), enableFiltering: true, enableHiding: false },

                  {
                      name: 'quantity_total', displayName: $filter('translate')('gifts.quantity'), enableFiltering: false, enableHiding: false, enableSorting: false,

                  },
                  { name: 'FK_gifts_provider.name', displayName: $filter('translate')('gifts.provider_name'), enableFiltering: true, enableHiding: false },
                  { name: 'notes', displayName: $filter('translate')('gifts.notes'), enableFiltering: true, enableHiding: false },
                  {
                      name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                          { title: $filter('translate')('gifts.button_edit'), action: 'ui-sref="gifts.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                          { title: $filter('translate')('gifts.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                      ], { cssClass: "pull-right" })
                  },
                ],
                getData: function (options) {
                    if (filter) {
                        options.name = $scope.giftsFilter.name;
                        options.provider_id = $scope.giftsFilter.provider_id;
                    }

                    return Restangular.all('Gifts').getList(options);
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("gifts.edit", { id: rowEntity.id });
            }


            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('gifts.button_delete'),
                    message: $filter('translate')('gifts.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Gifts', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('gifts.delete_success'));
                            $scope.gridOptionsGifts.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };

            $scope.export = function () {
                var options = {
                    filters: {
                    }
                };
    
                datasetsService.exportByType("gifts", options);
            };


            $scope.searchGifts = function () {
                if (angular.isDefined($scope.gridOptionsGifts.loadData)) {
                    filter = true;
                    $scope.gridOptionsGifts.loadData(false);
                }
            }


        }])

        ;